<template>
  <div class="crop-svg-layer" v-show="isShow" @keydown.stop @click.stop @mousedown.stop>
    <!-- 覆盖整个页面，以及绑定drag -->
    <div
      class="layer-backdrop"
      v-dragWhole
      :style="{width: Window_Size.width + 'px', height: Window_Size.height + 'px'}"
    >
      <!-- 将定位对应同步到画布 -->
      <div class="layer-position" :style="positionStyle">
        <!-- 完整图片 -->
        <div class="layer-bottom" :style="bottomStyle">
          <img :src="url" />
        </div>
        <!-- 裁剪后的图片svg -->
        <div class="layer-content" :style="contentStyle">
          <div id="cropSvgLayer"></div>
        </div>
        <!-- 操作和拖动层 -->
        <div class="layer-help" data-action="move" :style="helpStyle">
          <div
            :class="'op-handle-point op-handle-' + point.action"
            v-for="point in contentPoint"
            :data-action="point.action"
            :style="point.pt"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dragFn from "@/components/mixins/forDragFn";

export default {
  name: "CropSvgLayer",
  mixins: [dragFn],
  data() {
    return {
      isShow: false,
      sprite: null,
      url: "", // 图片地址
      svgUrl: "", // 相框地址
      rotate: 0, // 元素旋转角度
      draw: null, // 相框svg dom
      clipPath: null, // 裁剪 dom
      picDom: null, // 图片 dom
      content: {
        // 元素对应的大小，旋转，镜像
        w: 0,
        h: 0,
        t: 0,
        l: 0,
        o: 0,
        f: false
      },
      handle: {
        // 操作层的大小和定位
        w: 0,
        h: 0,
        t: 0,
        l: 0
      },
      info: {
        // 图片的原始大小和定位，偏移，裁剪之后的大小
        ow: 0,
        oh: 0,
        dx: 0,
        dy: 0,
        w: 0,
        h: 0,
        ol: 0,
        ot: 0
      },
      bbox: {
        // 相框的svg的bbox
        w: 0,
        h: 0
      },
      action: "", // 当前拖动的动作
      pitch: null, // 拖动的中间变量
      mpos: null, // mousedown的初始值对象
      contentPoint: [
        // 帮助层按钮，缩放和旋转
        { pt: { left: "calc(50% - 4px)", bottom: "-4px" }, action: "s" },
        { pt: { left: "-6px", bottom: "-6px" }, action: "sw" },
        { pt: { left: "-3.5px", top: "calc(50% - 4px)" }, action: "w" },
        { pt: { left: "-6px", top: "-6px" }, action: "nw" },
        { pt: { left: "calc(50% - 4px)", top: "-4px" }, action: "n" },
        { pt: { right: "-6px", top: "-6px" }, action: "ne" },
        { pt: { right: "-3.5px", top: "calc(50% - 4px)" }, action: "e" },
        {
          pt: { right: "-6px", bottom: "-6px", left: "auto", top: "auto" },
          action: "se"
        }
      ],
      cursorArr: [
        // 对应操作点的鼠标样式
        "s-resize",
        "sw-resize",
        "w-resize",
        "nw-resize",
        "n-resize",
        "ne-resize",
        "e-resize",
        "se-resize"
      ],
      line: null // 对称直线
    };
  },
  computed: {
    ...mapGetters([
      "Window_Size",
      "SelectSprites_Msg",
      "TOOL",
      "MaterialPane_Size",
      "TopNav_Size"
    ]),
    positionStyle() {
      const style = {};
      style.width = this.TOOL.clientWidth + "px";
      style.height = this.TOOL.clientHeight + "px";
      style.top = this.TOOL.fixTop + this.TopNav_Size.height + 40 + "px";
      style.left = this.TOOL.fixLeft + this.MaterialPane_Size.width + "px";
      return style;
    },
    contentStyle() {
      const style = {};
      style.width = this.content.w + "px";
      style.height = this.content.h + "px";
      style.top = this.content.t + "px";
      style.left = this.content.l + "px";
      style.transform =
        "rotate(" +
        this.rotate +
        "deg)" +
        (this.content.f ? " scaleX(-1)" : "");
      return style;
    },
    bottomStyle() {
      const style = {};
      style.width = this.info.ow + "px";
      style.height = this.info.oh + "px";
      style.top = this.info.ot + "px";
      style.left = this.info.ol + "px";
      style.transform =
        "rotate(" +
        this.rotate +
        "deg)" +
        (this.content.f ? " scaleX(-1)" : "");
      return style;
    },
    helpStyle() {
      const style = {};
      style.width = this.handle.w + "px";
      style.height = this.handle.h + "px";
      style.top = this.handle.t + "px";
      style.left = this.handle.l + "px";
      style.transform = "rotate(" + this.rotate + "deg)";
      return style;
    }
  },
  mounted() {
    this.$bus.on("cropsvglayer", data => {
      if (data === false) {
        this.isShow && this.close();
      } else {
        this.init(data);
      }
    });
    this.$bus.on("cropping.uncrop", () => {
      this.isShow && this.cancelSvgCrop();
    });
    this.$bus.on("cropping.confirm", () => {
      this.isShow && this.setSvgCrop();
    });
    this.$bus.on("cropping.cancel", () => {
      this.isShow && this.close();
    });
    this.$bus.on("cropping.select", url => {
      if (this.isShow) {
        if (this.sprite.cropUrl === url) return;
        this.svgUrl = url;
        this.content.l = this.info.ol;
        this.content.t = this.info.ot;
        this.initDom();
      } else {
        this.init({ url: url });
        this.$nextTick(() => {
          this.sprite.action = "svgCroping";
        });
      }
    });
  },
  methods: {
    init(data) {
      // 初始话数据
      if (this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        this.$store.commit("toggle_isPreventDefault", false);
        this.sprite = this.SelectSprites_Msg[0];
        this.isShow = true;
        this.sprite.showHideSpriteDom(false);
        this.sprite.action = "svgCroping";
        this.$bus.emit("updateEffect_vue", { type: "svgCroping" });
        this.url = this.$handleAssetsUrl(this.sprite.option.url);

        this.content = {
          w: this.sprite.width,
          h: this.sprite.height,
          t: this.sprite.positionTop,
          l: this.sprite.positionLeft,
          f: this.sprite.flip,
          o: this.sprite.opacity
        };
        this.rotate = this.sprite.rotate;

        if (this.sprite.cropType === "svg") {
          // svg -> svg
          this.svgCropInit();
          this.initDom(true);
        } else if (this.sprite.cropType === "free") {
          // free -> svg
          let o1 = this.freeCropInit(this.sprite.cropBoxData);
          this.svgUrl = data.url;
          this.info.ol = o1.x - this.info.ow / 2;
          this.info.ot = o1.y - this.info.oh / 2;
          this.content.t = this.info.ot;
          this.content.l = this.info.ol;
          this.initDom();
        } else {
          // null -> svg
          this.svgUrl = data.url;
          this.info.ow = this.content.w;
          this.info.oh = this.content.h;
          this.info.ol = this.content.l;
          this.info.ot = this.content.t;
          this.info.ratio = this.info.ow / this.info.oh;
          this.initDom();
        }
        this.setCursor(this.rotate);
      } else {
        this.isShow = false;
      }
    },
    svgCropInit() {
      // svg -> svg对应的处理
      this.svgUrl = this.sprite.cropUrl;
      let boxData = this.sprite.cropBoxData;
      let rW = this.sprite.width / boxData.width;
      let rH = this.sprite.height / boxData.height;
      this.info.ow = boxData.originWidth * rW;
      this.info.oh = boxData.originHeight * rH;
      this.info.ratio = this.info.ow / this.info.oh;
      this.info.w = this.sprite.width;
      this.info.h = this.sprite.height;
      this.info.dx = boxData.deltaX * rW;
      this.info.dy = boxData.deltaY * rH;
      let oC = {
          x: this.content.l + this.info.dx + this.info.ow / 2,
          y: this.content.t + this.info.dy + this.info.oh / 2
        },
        handleC = {
          x: this.content.l + this.content.w / 2,
          y: this.content.t + this.content.h / 2
        };

      let o1 = this._rotateWithPoint(oC, handleC, this.rotate);
      if (this.content.f) {
        this.line = this._getLine(handleC, -this.rotate);
        o1 = this._getFlipPoint(this.line, o1);
      }
      this.info.ol = o1.x - this.info.ow / 2;
      this.info.ot = o1.y - this.info.oh / 2;
      this.bbox.w = this.sprite.bbox.w;
      this.bbox.h = this.sprite.bbox.h;
      this.info.sx = this.info.w / this.bbox.w;
      this.info.sy = this.info.h / this.bbox.h;
    },
    freeCropInit(data) {
      // free -> svg数据处理
      let f = this.content.f ? -1 : 1;
      this.rotate = this.content.f
        ? this.sprite.rotate * 2 - data.innerRotation
        : data.innerRotation;
      this.info.ow = data.originWidth;
      this.info.oh = data.originHeight;
      this.info.ratio = this.info.ow / this.info.oh;
      let c1 = {
        x: f * data.deltaX,
        y: data.deltaY
      };
      let rad = (this.sprite.rotate * Math.PI) / 180;
      let vt1 = {
        x: c1.x * Math.cos(rad) - c1.y * Math.sin(rad),
        y: c1.x * Math.sin(rad) + c1.y * Math.cos(rad)
      };
      let sC = {
        x: this.content.l + this.content.w / 2,
        y: this.content.t + this.content.h / 2
      };
      return {
        x: sC.x + vt1.x,
        y: sC.y + vt1.y
      };
    },
    initDom(bol) {
      // 初始化dom结构
      $("#cropSvgLayer").empty();
      let draw = SVG("cropSvgLayer");
      let maskId = this.sprite.uuid + "-crop-svg-set";
      if (bol) {
        // 使用元素层的dom结构
        draw.attr({
          viewBox: `0 0 ${this.info.w} ${this.info.h}`,
          overflow: "hidden"
        });
        var defs = this.sprite.draw.select("defs").members[0].clone();
        this.clipPath = defs.children()[0];
        this.clipPath
          .transform({
            scaleX: this.info.sx,
            scaleY: this.info.sy
          })
          .attr("id", maskId);
        draw.defs().add(this.clipPath);
        defs.remove();
        this.picDom = draw
          .group()
          .attr("clip-path", `url(#${maskId})`)
          .image(this.url);
        this.picDom
          .size(this.info.ow, this.info.oh)
          .move(this.info.dx, this.info.dy)
          .attr("preserveAspectRatio", "none");
        this.draw = draw;
        this.handle.w = this.info.w;
        this.handle.h = this.info.h;
        this.handle.t = this.content.t;
        this.handle.l = this.content.l;
      } else {
        // 获取相框，生成svg对象
        this.$fetch(this.$handleAssetsUrl(this.svgUrl))
          .then(res => {
            return res.text();
          })
          .then(txt => {
            let reg = /<path(.)*?id="lhImageFrame"(.)*?class="(.)*?"/;
            txt = txt.replace(
              reg,
              '<path class="imageHolderMaskPath" fill="none" '
            );
            draw.svg(txt);
            let maskPathDom = draw.select(".imageHolderMaskPath");
            let bbox = draw
              .select("svg")
              .members[0].attr("viewBox")
              .split(" ");
            this.bbox.w = +bbox[2];
            this.bbox.h = +bbox[3];
            this.bbox.ratio = this.bbox.w / this.bbox.h;
            // cacl 数据
            if (this.info.ratio > this.bbox.ratio) {
              this.info.h = this.info.oh * 0.8;
              this.info.w = this.info.h * this.bbox.ratio;
              this.info.dy = -this.info.oh * 0.1;
              this.info.dx = (this.info.w - this.info.ow) / 2;
            } else {
              this.info.w = this.info.ow * 0.8;
              this.info.h = this.info.w / this.bbox.ratio;
              this.info.dx = -this.info.ow * 0.1;
              this.info.dy = (this.info.h - this.info.oh) / 2;
            }
            this.info.sx = this.info.h / this.bbox.h;
            this.info.sy = this.info.sx;

            this.content.w = this.info.w;
            this.content.h = this.info.h;
            this.content.t -= this.info.dy;
            this.content.l -= this.info.dx;
            this.handle.w = this.info.w;
            this.handle.h = this.info.h;
            this.handle.t = this.content.t;
            this.handle.l = this.content.l;

            draw.clear().attr({
              viewBox: `0 0 ${this.info.w} ${this.info.h}`,
              overflow: "hidden"
            });
            this.draw = draw;
            this.clipPath = draw
              .defs()
              .clip()
              .attr("id", maskId);
            this.clipPath.transform({
              scaleX: this.info.sx,
              scaleY: this.info.sy
            });
            this.clipPath.add(maskPathDom.members[0]);
            this.picDom = draw
              .group()
              .attr("clip-path", `url(#${maskId})`)
              .image(this.url);
            this.picDom
              .size(this.info.ow, this.info.oh)
              .move(this.info.dx, this.info.dy)
              .attr("preserveAspectRatio", "none");
          });
      }
    },
    dragDown(disx, action) {
      // mousedown数据的初始位置
      if (!action) {
        this.setSvgCrop();
        return;
      }
      this.sprite.showHideSpriteDom(false);
      this.action = action;
      this.pitch = Object.assign({}, this.handle);
      this.mpos = Object.assign(
        {
          x: disx.x - this.TOOL.PfixLeft,
          y: disx.y - this.TOOL.PfixTop,
          cx: this.pitch.l + this.pitch.w / 2,
          cy: this.pitch.t + this.pitch.h / 2
        },
        this.pitch
      );
    },
    dragMove(pos) {
      if (!this.action) {
        return;
      }
      pos.x -= this.TOOL.PfixLeft;
      pos.y -= this.TOOL.PfixTop;
      let mpos = this.mpos,
        direction = "",
        size = {
          w: 0,
          h: 0
        },
        scaleSize = 0;
      switch (this.action) {
        case "e": // 右
          size.w = Math.abs(
            mpos.w +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          direction = "top-left";
          this.pitch.w = size.w;
          break;
        case "s":
          size.h = Math.abs(
            mpos.h +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          direction = "top-left";
          this.pitch.h = size.h;
          break;
        case "w":
          size.w = Math.abs(
            mpos.w +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          direction = "top-right";
          this.pitch.w = size.w;
          break;
        case "n":
          size.h = Math.abs(
            mpos.h +
              this._changeLength(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          direction = "bottom-right";
          this.pitch.h = size.h;
          break;
        case "se":
          direction = "top-left";
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          this.pitch.w = mpos.w * scaleSize;
          this.pitch.h = mpos.h * scaleSize;
          break;
        case "sw":
          direction = "top-right";
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          this.pitch.w = mpos.w * scaleSize;
          this.pitch.h = mpos.h * scaleSize;
          break;
        case "nw":
          direction = "bottom-right";
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          this.pitch.w = mpos.w * scaleSize;
          this.pitch.h = mpos.h * scaleSize;
          break;
        case "ne":
          direction = "bottom-left";
          scaleSize = Math.abs(
            this._scaleSize(pos.x, pos.y, mpos.x, mpos.y, mpos.cx, mpos.cy)
          );
          this.pitch.w = mpos.w * scaleSize;
          this.pitch.h = mpos.h * scaleSize;
          break;
        case "move":
          this.pitch.l = mpos.l + pos.x - mpos.x;
          this.pitch.t = mpos.t + pos.y - mpos.y;
          break;
      }
      if (direction) {
        let position = this._rotSize(
          this.pitch.w,
          this.pitch.h,
          mpos.w,
          mpos.h,
          mpos.l,
          mpos.t,
          this.rotate,
          direction
        );
        this.pitch.l = position.left;
        this.pitch.t = position.top;
      }
      Object.assign(this.handle, this.pitch);
      this.handle2mask();
    },
    dragUp() {
      this.action = "";
      this.mpos = null;
    },
    handle2mask() {
      // 帮助层到正确的相框裁剪位置
      Object.assign(this.content, this.handle);
      let oC = {
          x: this.info.ol + this.info.ow / 2,
          y: this.info.ot + this.info.oh / 2
        },
        handleC = {
          x: this.handle.l + this.handle.w / 2,
          y: this.handle.t + this.handle.h / 2
        };
      let o1 = this._rotateWithPoint(oC, handleC, -this.rotate);
      if (this.content.f) {
        this.line = this._getLine(handleC, 0);
        o1 = this._getFlipPoint(this.line, o1);
      }
      this.info.dx = o1.x - handleC.x + this.handle.w / 2 - this.info.ow / 2;
      this.info.dy = o1.y - handleC.y + this.handle.h / 2 - this.info.oh / 2;
      this.draw
        .attr({
          viewBox: `0 0 ${this.handle.w} ${this.handle.h}`
        })
        .size(this.handle.w, this.handle.h);
      this.clipPath.attr(
        "transform",
        `scale(${this.handle.w / this.bbox.w}, ${this.handle.h / this.bbox.h})`
      );
      this.picDom.move(this.info.dx, this.info.dy);
    },
    setSvgCrop() {
      // 设置svg裁剪
      let boxData = {
        width: this.content.w,
        height: this.content.h,
        top: this.handle.t,
        left: this.handle.l,
        originWidth: this.info.ow,
        originHeight: this.info.oh,
        deltaX: this.info.dx,
        deltaY: this.info.dy,
        rotate: this.rotate
      };
      this.sprite.setSvgCrop(boxData, this.svgUrl, true).then(() => {
        this.$bus.emit("updateEffect_vue", { type: "svgCropSet" });
      });
      this.close();
    },
    cancelSvgCrop() {
      // 取消裁剪
      let data = {
        width: this.info.ow,
        height: this.info.oh,
        positionTop: this.info.ot,
        positionLeft: this.info.ol
      };
      this.sprite.cancelCrop(data, true);
      this.$bus.emit("updateEffect_vue", { type: "svgCropSet" });
      this.close();
    },
    close() {
      // 关闭弹窗
      this.isShow = false;
      this.sprite.action = "";
      this.sprite.showHideSpriteDom(true);
      this.sprite = null;
      this.draw.remove();
      this.draw = null;
      this.clipPath = null;
      this.picDom = null;
      this.$store.commit("toggle_isPreventDefault", true);
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3
      });
    },
    setCursor(deg) {
      // 设置鼠标样式
      let showClassArr = [],
        sliceIndex = 0;

      if (deg < -22.5) {
        deg = deg + 360;
      } else if (deg > 347.5) {
        deg = deg - 360;
      }
      // 每隔45° 数组变化一次，将第一个数据放入到最后
      sliceIndex = parseInt((deg + 22.5) / 45);
      showClassArr = this.cursorArr
        .slice(sliceIndex)
        .concat(this.cursorArr.slice(0, sliceIndex));

      for (var i = 0; i < this.contentPoint.length; i++) {
        this.contentPoint[i].pt.cursor = showClassArr[i];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.crop-svg-layer {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(248, 248, 248, 0.75);
  z-index: 25;
}
.layer-position {
  position: absolute;
}
.layer-content,
.layer-help {
  position: absolute;
}
.layer-help {
  box-sizing: border-box;
  border: 1px dashed #37484f;
}
.layer-bottom {
  position: absolute;
  opacity: 0.5;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CropSvgLayer.vue